import { httpClient } from 'core/net/http';
import { BlastScenarioResponse } from 'app/business-logic/domain-models/Blasting';

export async function fetchBlastScenario(alias?: string): Promise<BlastScenarioResponse | null> {
  const response = await httpClient.useInternalApi.asAuthorised().get(`/blasting/scenarios/${alias}`);
  if (!response.isSuccess) return null;
  return response.data as BlastScenarioResponse;
}
